import { useEffect, useState } from 'react';
import { loadProcessArchsAllCached, loadProcessArchsCached, ProcessArch } from '../../api/dict';

// 加工模式组「适用框架」的数据侧 (2026-10-22): 选项来自工艺框架注册表, 不在代码里列框架.
// 与 archs.tsx (展示组件) 分文件: 组件文件只导出组件, 保证 fast refresh.

/**
 * 工艺框架列表, 模块级缓存. enabledOnly = 只要启用的 (可选项); 否则含停用 (显示名用: 已绑定的停用框架也能显示中文名).
 */
export function useProcessArchs(enabledOnly = false): ProcessArch[] {
    const [archs, setArchs] = useState<ProcessArch[]>([]);
    useEffect(() => {
        let alive = true;
        (enabledOnly ? loadProcessArchsCached() : loadProcessArchsAllCached()).then((list) => {
            if (alive) setArchs(list);
        });
        return () => {
            alive = false;
        };
    }, [enabledOnly]);
    return archs;
}

/** 模式组是否适用某框架: archCodes 为空 = 不限. */
export function groupAppliesToArch(archCodes: string[] | null | undefined, archCode: string): boolean {
    return !archCodes || archCodes.length === 0 || archCodes.includes(archCode);
}
